import { Dashboard } from '@akin-home/amplify';
import {
  dashboardGraphqlToModel,
  getDashboardQuery,
} from '@akin-home/dashboards/frontend';
import { useQuery } from 'react-query';
import { dashboard_query_keys } from './query_keys';

export const useGetDashboard = (id: string) =>
  useQuery(dashboard_query_keys.detail(id), () => getDashboardQuery({ id }), {
    select({ data }) {
      return dashboardGraphqlToModel(data.getDashboard as Dashboard);
    },
  });
